import { render, staticRenderFns } from "./SinglePurchaseNew.vue?vue&type=template&id=265cd1c8&"
import script from "./SinglePurchaseNew.vue?vue&type=script&lang=js&"
export * from "./SinglePurchaseNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports